module.exports = __webpack_public_path__ + "static/modal-action-do-074b12a19c59b5f6b70c2e2be8c45bcd.png";